import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '../../../lib/utils.ts';

const badgeVariants = cva(
    'inline-flex items-center text-center rounded-full transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2 gap-1 text-nowrap',
    {
        variants: {
            variant: {
                default: 'bg-white border',
            },
            size: {
                default: 'h-6 space-x-2 px-2.5 text-xs leading-none',
            },
            color: {
                default: 'border-green-300 text-emerald-600 ',
                green: 'border-green-300 text-emerald-600 ',
                red: 'border-red-300 text-red-600',
                neutral: 'border-neutral-300 text-neutral-600',
                yellow: 'border-yellow-300 text-yellow-600 ',
                orange: 'border-orange-300 text-orange-600 ',
                blue: 'border-blue-300 text-blue-600 ',
            },
        },
        defaultVariants: {
            variant: 'default',
            size: 'default',
            color: 'default',
        },
    },
);

export type BadgeProps = {
    color?: 'default' | 'green' | 'red' | 'neutral' | 'yellow' | 'orange' | 'blue';
    icon?: React.ComponentType<React.SVGAttributes<SVGElement>>;
} & Omit<React.HTMLAttributes<HTMLSpanElement>, 'color'> &
    VariantProps<typeof badgeVariants>;

function Badge({ className, color, variant, size, children, icon: Icon, ...props }: BadgeProps) {
    return (
        <span className={cn(badgeVariants({ size, color, variant }), className)} {...props}>
            {Icon && <Icon className="h-4 w-4" />}
            {children}
        </span>
    );
}

export { Badge, badgeVariants };
